import { Currency } from '@/core/currency/interfaces';

const EUR: Currency = {
    name: 'Euro',
    demonym: '',
    majorSingle: 'Euro',
    majorPlural: 'Euros',
    codeNumeric: '978',
    symbol: '€',
    symbolNative: '€',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'EUR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default EUR;
